import { IconNameLiterals } from '@trukt/types/icon';
import {
  FiMessageSquare,
  FiFileText,
  FiCornerUpLeft,
  FiCheckCircle,
  FiX,
  FiAlertCircle,
  FiMinusCircle,
  FiXCircle,
  FiPlusCircle,
  FiTrash,
  FiArrowUpCircle,
  FiArrowDownCircle,
  FiPercent,
  FiDollarSign,
  FiChevronDown,
  FiChevronUp,
  FiLoader,
  FiUpload,
  FiHelpCircle,
  FiUploadCloud,
  FiCheck,
  FiCalendar,
  FiChevronRight,
  FiChevronLeft,
  FiArrowLeft,
  FiArrowRight,
  FiArrowRightCircle,
  FiMail,
  FiPhone,
  FiSave,
} from 'react-icons/fi';

import {
  FaTrashAlt,
  FaCar,
  FaMap,
  FaRegCircle,
  FaShoppingBag,
  FaArrowCircleDown,
  FaArrowCircleUp,
  FaMinusCircle,
  FaHandPaper,
  FaCircle,
  FaRegCopy,
} from 'react-icons/fa';
import { AiFillPlusCircle, AiFillPrinter } from 'react-icons/ai';
import { BsGearWideConnected, BsTelephoneFill } from 'react-icons/bs';
import { TbCloudCancel, TbFileExport, TbWiper } from 'react-icons/tb';

import { MdEdit, MdOutlineMergeType, MdSearch, MdEmail, MdCheckBox } from 'react-icons/md';

import { IoMdPeople, IoMdPerson, IoMdDownload } from 'react-icons/io';
import { CiMemoPad } from 'react-icons/ci';
import { IoBarcodeSharp } from 'react-icons/io5';

import { IconType } from 'react-icons';
import { IconSizeLiterals } from './Icon.types';

export const ICON_MAP: Record<IconNameLiterals, IconType> = {
  'alert-circle': FiAlertCircle,
  'arrow-down-circle-solid': FaArrowCircleDown,
  'arrow-down-circle': FiArrowDownCircle,
  'arrow-left': FiArrowLeft,
  'arrow-right-circle': FiArrowRightCircle,
  'arrow-right': FiArrowRight,
  'arrow-up-circle-solid': FaArrowCircleUp,
  'arrow-up-circle': FiArrowUpCircle,
  'check-box': MdCheckBox,
  'check-circle': FiCheckCircle,
  'chevron-down': FiChevronDown,
  'chevron-left': FiChevronLeft,
  'chevron-right': FiChevronRight,
  'chevron-up': FiChevronUp,
  'cloud-cancel': TbCloudCancel,
  'corner-up-left': FiCornerUpLeft,
  'dollar-sign': FiDollarSign,
  'empty-circle': FaRegCircle,
  'file-export': TbFileExport,
  'file-text': FiFileText,
  'filled-circle': FaCircle,
  'help-circle': FiHelpCircle,
  'io-md-people': IoMdPeople,
  'io-md-person': IoMdPerson,
  'mail-filled': MdEmail,
  'market-place': FaShoppingBag,
  'message-square': FiMessageSquare,
  'minus-circle-filled': FaMinusCircle,
  'minus-circle': FiMinusCircle,
  'phone-filled': BsTelephoneFill,
  'plus-circle-filled': AiFillPlusCircle,
  'plus-circle': FiPlusCircle,
  'trash-alt': FaTrashAlt,
  'upload-cloud': FiUploadCloud,
  'x-circle': FiXCircle,
  barcode: IoBarcodeSharp,
  calendar: FiCalendar,
  car: FaCar,
  check: FiCheck,
  copy: FaRegCopy,
  download: IoMdDownload,
  edit: MdEdit,
  gear: BsGearWideConnected,
  hand: FaHandPaper,
  loader: FiLoader,
  mail: FiMail,
  map: FaMap,
  memopad: CiMemoPad,
  merge: MdOutlineMergeType,
  percent: FiPercent,
  phone: FiPhone,
  printer: AiFillPrinter,
  save: FiSave,
  search: MdSearch,
  trash: FiTrash,
  upload: FiUpload,
  wiper: TbWiper,
  x: FiX,
};

export const ICON_SIZE_MAP: Record<IconSizeLiterals, string> = {
  sm: '1rem',
  md: '1.2rem',
  lg: '1.5rem',
  xl: '2rem',
};
